import React, { useEffect, useState } from "react";
import { fetchPendingReservationForTable, createOrderFromReservation } from "../../../../../../../../services/pos/reservation/reservationApi";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  CardActions,
  Stack,
} from "@mui/material";

const ShowTableReservation = ({ tableId }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallTablet = useMediaQuery("(min-width:600px) and (max-width:768px)");
  const isMediumTablet = useMediaQuery("(min-width:769px) and (max-width:900px)");
  const isLargeTablet = useMediaQuery("(min-width:901px) and (max-width:1024px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1024px)");

  // responsive sizing
  const fontSize = isXs ? 12 : isSmallTablet ? 13 : isMediumTablet ? 14 : 15;
  const cellFontSize = isXs ? 11 : isSmallTablet ? 12 : 13;
  const btnSize = isXs ? "small" : isSmallTablet ? "small" : "medium";
  const btnHeight = isXs ? 36 : isSmallTablet ? 40 : 44;

  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [convertLoadingId, setConvertLoadingId] = useState(null); // للحالة أثناء التحويل
  const [successMsg, setSuccessMsg] = useState(""); // رسالة النجاح

  useEffect(() => {
    if (!tableId) return;
    setLoading(true);
    fetchPendingReservationForTable(tableId)
      .then((res) => {
        console.log("📡 بيانات الحجز:", res);
        // ✅ لو الرد Array مباشرة
        setReservations(Array.isArray(res) ? res : []);
      })
      .catch(() => setReservations([]))
      .finally(() => setLoading(false));
  }, [tableId]);

  // دالة تحويل الحجز إلى طلب (يمكنك تعديلها حسب منطقك)
  const handleConvertToOrder = async (reservation) => {
    setConvertLoadingId(reservation.id);
    try {
      const result = await createOrderFromReservation(reservation.id);
      setSuccessMsg(`✅ تم تحويل الحجز رقم ${reservation.id} إلى طلب بنجاح!`);
      // يمكنك هنا تحديث الحالة أو إعادة تحميل الطلبات إذا لزم الأمر
      setTimeout(() => setSuccessMsg(""), 3500); // إخفاء الرسالة بعد 3.5 ثانية
    } catch (error) {
      alert(error.message || "❌ حدث خطأ أثناء تحويل الحجز إلى طلب.");
    } finally {
      setConvertLoadingId(null);
    }
  };

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        حجوزات الطاولة
      </Typography>

      {successMsg && (
        <Box sx={{
          mb: 2,
          p: 2,
          bgcolor: "#e0ffe0",
          color: "#2e7d32",
          borderRadius: "8px",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "16px",
          boxShadow: 1,
        }}>
          {successMsg}
        </Box>
      )}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
          <CircularProgress />
        </Box>
      ) : reservations.length === 0 ? (
        <Typography color="text.secondary" align="center" sx={{ my: 2 }}>
          لا توجد حجوزات معلقة لهذه الطاولة.
        </Typography>
      ) : (
        <>
          {/* عرض جدول للشاشات المتوسطة فما فوق، وقائمة بطاقات للشاشات الصغيرة */}
          {!isXs ? (
            <TableContainer
              component={Paper}
              sx={{
                overflowX: "auto",
                width: "100%",
                boxSizing: "border-box",
                bgcolor: "transparent",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: cellFontSize }}>الطاولة</TableCell>
                    <TableCell>التاريخ</TableCell>
                    <TableCell sx={{ fontSize: cellFontSize }}>الوقت</TableCell>
                    <TableCell sx={{ fontSize: cellFontSize }}>عدد الأشخاص</TableCell>
                    <TableCell sx={{ fontSize: cellFontSize }}>الحالة</TableCell>
                    <TableCell sx={{ fontSize: cellFontSize }}>ملاحظات</TableCell>
                    <TableCell sx={{ fontSize: cellFontSize }}>تحويل</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservations.map((r) => (
                    <TableRow key={r.id}>
                      <TableCell sx={{ fontSize }}>{r.table?.name || "-"}</TableCell>
                      <TableCell sx={{ fontSize }}>{r.reservation_date}</TableCell>
                      <TableCell sx={{ fontSize }}>
                        {(() => {
                          if (!r.reservation_time) return "-";
                          const [h, m] = r.reservation_time.split(":");
                          let hour = Number(h);
                          const ampm = hour >= 12 ? "م" : "ص";
                          hour = hour % 12 || 12;
                          return `${hour}:${m} ${ampm}`;
                        })()}
                      </TableCell>
                      <TableCell sx={{ fontSize }}>{r.number_of_people}</TableCell>
                      <TableCell sx={{ fontSize, color: r.status === "pending" ? "#ff9800" : "inherit" }}>
                        {r.status === "pending" ? "⏳ معلق" : r.status}
                      </TableCell>
                      <TableCell sx={{ fontSize }}>{r.note || "-"}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size={btnSize}
                          onClick={() => handleConvertToOrder(r)}
                          disabled={convertLoadingId === r.id}
                          sx={{
                            fontSize,
                            height: btnHeight,
                            px: 2,
                            borderRadius: 2,
                            minWidth: 160,
                          }}
                        >
                          {convertLoadingId === r.id ? <CircularProgress size={18} /> : "تحويله إلى طلب"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Stack spacing={2}>
              {reservations.map((r) => (
                <Card key={r.id} variant="outlined" sx={{ bgcolor: "transparent" }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, alignItems: "flex-start", flexWrap: "wrap" }}>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={700}>
                          <span style={{ fontSize }}>{r.table?.name ? `طاولة ${r.table?.name}` : `حجز #${r.id}`}</span>
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontSize }}>
                          {r.reservation_date} — {(() => {
                            if (!r.reservation_time) return "-";
                            const [h, m] = r.reservation_time.split(":");
                            let hour = Number(h);
                            const ampm = hour >= 12 ? "م" : "ص";
                            hour = hour % 12 || 12;
                            return `${hour}:${m} ${ampm}`;
                          })()}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5, fontSize }}>
                          الأشخاص: <strong>{r.number_of_people}</strong>
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5, color: r.status === "pending" ? "#ff9800" : "inherit", fontSize }}>
                          الحالة: {r.status === "pending" ? "⏳ معلق" : r.status}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1, color: "text.secondary", whiteSpace: "pre-line", fontSize }}>
                          الملاحظات: {r.note || "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ px: 2, pb: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => handleConvertToOrder(r)}
                      disabled={convertLoadingId === r.id}
                      sx={{ py: 1, height: btnHeight, fontSize }}
                    >
                      {convertLoadingId === r.id ? <CircularProgress size={18} /> : "تحويله إلى طلب"}
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </Stack>
          )}
        </>
      )}
    </Box>
  );
};

export default ShowTableReservation;
